// extracted by mini-css-extract-plugin
module.exports = {"container":"RegistrationLayoutView_container__3fUdL","content":"RegistrationLayoutView_content__2xgbR"};